import React, { useState } from 'react';
import ReactGA from 'react-ga4';
import { toast } from 'sonner';
import { useTranslation } from 'react-i18next';
////////////////////////////////////////////////////////////////////
import { useCustomDispatch } from '@/core/redux/hooks';
import { telegramWebApp } from '@/main';
import {
	ClaimCollectionRewardResponse,
	StickerCollection,
} from '@/core/interfaces';
import {
	Button,
	DiamondImage,
	RewardCollection,
} from '@/app/shared/components';
import { CollectionsService } from '@/core/services';
import {
	setCounter,
	setDiamonds,
	setTotalCoinsGenerated,
} from '@/core/redux/slices';

interface CollectionItemProps {
	collection: StickerCollection;
}

export const CollectionsCarouselItem: React.FC<CollectionItemProps> = ({
	collection,
}) => {
	/*********************
	// #region Hooks
	**********************/
	const dispatch = useCustomDispatch();
	const { t } = useTranslation();

	/*********************
	// #region States
	**********************/
	const [visibleModalReward, setVisibleModalReward] =
		useState<boolean>(false);
	const [newDiamonds, setNewDiamonds] = useState<number>(0);

	/*********************
	// #region Functions
	**********************/
	const handleCollectionClaim = () => {
		telegramWebApp.HapticFeedback.impactOccurred('heavy');

		toast.promise(CollectionsService.claimCollectionReward(collection.id), {
			loading: t('general.loading'),
			success: (data: ClaimCollectionRewardResponse) => {
				// Emit event to Google Analytics
				ReactGA.event({
					category: 'rewards',
					action: `Claim collection ${collection.title}`,
				});

				// Update counter
				dispatch(setCounter(data.currentCoins));
				// // Update diamonds
				dispatch(setDiamonds(data.currentDiamonds));
				// // Set total coins
				dispatch(setTotalCoinsGenerated(data.totalCoinsEarned));

				setNewDiamonds(data.newDiamonds || 0);

				if (data.newDiamonds && data.newDiamonds > 0) {
					setVisibleModalReward(true);
				}

				return t('collections.claimRewardsConfirm');
			},
			error: t('collections.claimRewardsError'),
		});
	};

	/*********************
	// #region Template
	**********************/
	return (
		<>
			<div className="flex justify-center">
				<div className="grid grid-rows-3 grid-cols-3 my-6 justify-center w-[333px] h-[333px]">
					{collection.stickers.map((sticker) => {
						return (
							<img
								key={sticker.position.toString()}
								className="mx-auto h-[111px] w-[111px] border-none"
								src={sticker.image}
								alt={sticker.position.toString()}
							/>
						);
					})}
				</div>
			</div>

			<div className="mx-6">
				{collection.completed && !collection.claimed ? (
					<Button
						variant={'secondary'}
						onClick={handleCollectionClaim}
					>
						<DiamondImage classes="w-[18px]" />
						<span className="px-2">
							{t('general.claimRewards')}
						</span>
						<DiamondImage classes="w-[18px]" />
					</Button>
				) : (
					<>
						{collection.claimed ? (
							<p className="text-sm text-center">
								{t('general.claimed')} 🎉
							</p>
						) : (
							<p className="text-sm text-center">
								{t('collections.completeCollectionInfo')}
							</p>
						)}
					</>
				)}
			</div>

			<RewardCollection
				isOpen={visibleModalReward}
				onClose={setVisibleModalReward}
				newDiamonds={newDiamonds}
			/>
		</>
	);
};
